import { styled, SxProps } from "@mui/material/styles";

export type EmtSeparatorProps = {
  sx?: SxProps;
  nonce?: string;
};

const Separator = styled("div")(({ theme }) => ({
  height: "1px",
  width: "100%",
  padding: "0",
  background: theme.palette.divider,
}));

export function EmtSeparator(props: EmtSeparatorProps) {
  return <Separator {...props} />;
}
